export default {
    namespaced: true,
    state: {
        message: ''
    }
};
